<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 19:29:51
 * @LastEditTime: 2019-09-10 19:06:52
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">可查看自己下的订单，如需下单订购商品请登录经销商后台手机端。</div>

    <div class="btnBox">
      <el-button type="primary" @click="showLink=!showLink">经销商登陆地址</el-button>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="value.title"
        :name="'status-'+value.status"
        v-for="(value,key) in statusList"
        :key="key"
      ></el-tab-pane>
    </el-tabs>

    <el-form ref="form1" :model="form" label-width="120px" :inline="true">
      <el-form-item label="下单时间" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>

      <el-form-item>
        <el-select v-model="form.role">
          <el-option label="订单号" value="0"></el-option>
          <el-option label="产品编号" value="1"></el-option>
          <el-option label="产品名称" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.order_sn" clearable v-if="form.role==0"></el-input>
        <el-input v-model="form.product_sn" clearable v-if="form.role==1"></el-input>
        <el-input v-model="form.product_name" clearable v-if="form.role==2"></el-input>
      </el-form-item>
      <el-form-item label="是否赠品:">
        <el-select v-model="form.isgift">
          <el-option label="全部" value></el-option>
          <el-option label="赠品" value="1"></el-option>
          <el-option label="非赠品" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <el-button type="primary" @click="onExport()">导出</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom:10px">
      订单总数:
      <span style="color:red;margin-right:10px">{{total}}</span> 订单总额:
      <span style="color:red;margin-right:10px">{{parseFloat(outstock/100)}}</span>订单应发总数:
      <span style="color:red;margin-right:10px">{{order_num}}</span>订单实发总数:
      <span style="color:red;margin-right:10px">{{order_realNum}}</span>
    </div>
    <div
      class="tableBox"
      v-loading="loading"
      style="width: 100%;margin-bottom: 20px; overflow:auto"
    >
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px"
        border
        fit
        v-loading="loading"
        max-height="500"
      >
        <el-table-column prop="id" label="序号" sortable fixed="left">
          <template slot-scope="scope">{{scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="order_sn" label="订单号" fixed="left" width="180"></el-table-column>
        <el-table-column prop="created_at" fixed="left" label="下单时间" width="180"></el-table-column>

        <el-table-column prop="to_name" label="订单金额" width="180">
          <template slot-scope="scope">{{parseFloat(scope.row.total_fee/100)}}</template>
        </el-table-column>
        <el-table-column prop="total_stock_out_num" label="支付方式">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_type == 0">未支付</span>
            <span v-if="scope.row.pay_type == 1">线下支付</span>
            <span v-if="scope.row.pay_type == 2">微信支付</span>
          </template>
        </el-table-column>
        <el-table-column prop label="是否赠品" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.isgift == 1">赠品</span>
            <span v-else>非赠品</span>
          </template>
        </el-table-column>

        <el-table-column prop="order_notes" label="订单留言" width="180"></el-table-column>
        <el-table-column prop="product_sn" label="产品编号" width="180"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" width="180"></el-table-column>
        <el-table-column prop="product_specs" label="产品规格" width="180"></el-table-column>
        <el-table-column prop="stock_out_num" label="下单数量"></el-table-column>
        <el-table-column prop="real_stock_out_num" label="实发数量"></el-table-column>
        <el-table-column prop="expiring_date" fixed="right" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待发货</span>
            <span v-if="scope.row.status == 1">待收货</span>
            <span v-if="scope.row.status == 2">发货中</span>
            <span v-if="scope.row.status == 3">待付款</span>
            <span v-if="scope.row.status == 4">待审核</span>
            <span v-if="scope.row.status == 5">审核不通过</span>
            <span v-if="scope.row.status == 6">已完成</span>
            <span v-if="scope.row.status == 7">已取消</span>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="check(scope.row)">查看详情</el-button>
            <el-button
              type="text"
              size="small"
              @click="del(scope.row)"
              v-if="scope.row.status == 3||scope.row.status == 4||scope.row.status == 5||scope.row.status == 0"
            >取消订单</el-button>
            <el-button
              type="text"
              size="small"
              @click="confirm(scope.row)"
              v-if="scope.row.status == 1"
            >确认收货</el-button>
            <el-button
              type="text"
              size="small"
              @click="again(scope.row)"
              v-if="scope.row.status == 6||scope.row.status == 7"
            >再次下单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin: 20px 0"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageNo1"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize1"
      ></el-pagination>
    </div>
    <copyLinkDialog @handleClose="closeLink" v-if="showLink" />
  </div>
</template>
<script>
import copyLinkDialog from "@/common/copyLinkDialog";
import handlerTable from "@/until/handlerTable.js";
export default {
  name: "myorder",
  data() {
    return {
      loading: false,
      activeName: "status--1",
      showLink: false,
      form1: {
        product_sn: "",
        product_name: "",
        role: "0",
        isgift: "",
        start_time: "",
        end_time: ""
      },
      form: {
        product_sn: "",
        product_name: "",
        role: "0",
        isgift: "",
        custType: "",
        start_time: "",
        end_time: ""
      },
      tableData: [],
      //分页
      pageNo1: 1, //页码
      pageSize1: 20, //每页现实的条数
      totalSize1: 0, //总条数
      statusList: [],
      order_num: 0,
      order_realNum: 0,
      total: 0,
      outstock: 0
    };
  },
  methods: {
    getStatus() {
      this.$get("logistics_1", "/orders/status").then(res => {
        this.statusList = res.data;
        this.onSearch();
      });
    },
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }
      dateObj.now = year + "-" + month + "-" + day;
      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }
      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    onSearch() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        this.form.start_time = this.moment(this.form.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form.end_time) {
        this.form.end_time = this.moment(this.form.end_time).format(
          "YYYY-MM-DD"
        );
      }
      var status = this.activeName.replace("status-", "");
      this.$get("logistics_1", "/orders", {
        status: status,
        ...this.form,
        per_page: this.pageSize1,
        page: this.pageNo1,
        channel: 1,
        is_export: 0
      }).then(res => {
        this.order_num = res.sum_data.sum_stock_out_num;
        this.order_realNum = res.sum_data.sum_real_stock_out_num;
        this.total = res.sum_data.count;
        this.outstock = res.sum_data.total_fee;
        this.totalSize1 = res.sum_data.count;
        this.tableData = handlerTable(res.data, {
          keys: "product"
        });
      });
    },
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");
      if (process.env.NODE_ENV == "development") {
        url = "http://logistics.c.";
      } else if (process.env.NODE_ENV == "production") {
        url = "http://logistics.";
      } else {
        url = "http://logistics.c.";
      }
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      var status = this.activeName.replace("status-", "");
      window.open(
        process.env.VUE_APP_URL_V1 +
          "/orders.export? " +
          "&lang=" +
          "" +
          "&is_export=1" +
          "&start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&product_name=" +
          this.form.product_name +
          "&product_sn=" +
          this.form.product_sn +
          "&order_sn=" +
          this.form.order_sn +
          "&status=" +
          status +
          "&channel=1" +
          +"&signature=" +
          this.$md5(access_tokens)
      );
    },
    confirm(data) {
      this.$confirm("是否确认收货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let str = data.id,
            url = "/orders/rebate";
          this.$get("logistics_1", url, {
            order_id: str
          })
            .then(res => {
              this.$message({
                type: "success",
                message: "确认收货成功!"
              });
              this.onSearch();
            })
            .catch(function(error) {
              Message.error(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    check(data) {
      this.$router.push({
        name: "myorderDetail",
        query: {
          order_id: data.id
        }
      });
    },
    del(row) {
      this.$confirm("是否取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let str = row.id,
            url = "/orders/cancel";
          this.$delete("logistics_1", url, {
            order_id: str
          })
            .then(res => {
              this.$message({
                type: "success",
                message: "取消成功!"
              });
              this.onSearch();
            })
            .catch(function(error) {
              Message.error(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    again(row) {
      this.$confirm("是否再次下单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let str = row.id,
            url = "/orders​/place.order";
          this.$delete("logistics_1", url, {
            order_id: str
          })
            .then(res => {
              this.$message({
                type: "success",
                message: "再次下单成功!"
              });
              this.onSearch();
            })
            .catch(function(error) {
              Message.error(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleClick(value) {
      this.onSearch();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      //this.getDealerList();
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      //this.getDealerList();
      this.onSearch();
    },
    closeLink() {
      this.showLink = !this.showLink;
    }
  },
  components: {
    copyLinkDialog
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.getStatus();
  }
};
</script>
<style lang="scss" scoped>
.tableBox {
  overflow-x: scroll;
  min-height: 200px;
  .table {
    width: 300%;
  }
}
</style>


